import { Box, Button, Callout, Dialog, Intent, Text } from "@blasterjs/core";
import React from "react";

import { DialogBody, DialogFooter, DialogHeader } from "../components/DialogLayout";
import ReasonForChange from "../components/ReasonForChange";
import { useAppDispatch, useAppSelector } from "../hooks";
import {
  closeArchiveCaseDialog,
  caseArchive,
  setArchiveCaseForm
} from "../slices/archiveCaseDialog";
import { casesFetch } from "../slices/cases";

const archiveCaseDialog = () => {
  const dispatch = useAppDispatch();
  const archiveCaseDialog = useAppSelector(state => state.archiveCaseDialog);

  const closeDialog = () => {
    dispatch(closeArchiveCaseDialog());
  };

  const onConfirm = () => {
    archiveCaseDialog.isOpen &&
      dispatch(caseArchive()).then(() => {
        if (archiveCaseDialog.case.data.case.id) {
          dispatch(casesFetch(archiveCaseDialog.case.data.case.studyId));
        }
      });
  };

  const onChangeReasonForChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    archiveCaseDialog.isOpen &&
      dispatch(
        setArchiveCaseForm({
          ...archiveCaseDialog.case.data,
          reasonForChange: e.target.value
        })
      );
  };

  const errorText = archiveCaseDialog.isOpen && "errorMessage" in archiveCaseDialog.case && (
    <Box mb="2">
      <Callout intent={Intent.DANGER}>
        <Text>{archiveCaseDialog.case.errorMessage}</Text>
      </Callout>
    </Box>
  );

  const confirmDisabled = !(
    archiveCaseDialog.isOpen && archiveCaseDialog.case.data.reasonForChange
  );
  return (
    (archiveCaseDialog.isOpen && (
      <Dialog isOpen={archiveCaseDialog.isOpen} onRequestClose={closeDialog} appElementId="root">
        <DialogHeader title="Archive Case" closeDialog={closeDialog} />
        <DialogBody>
          {errorText}
          <Box>
            Are you sure you want to archive the following case?
            <br />
            All images in the case will also be archived.
            <br />
            <br />
            {archiveCaseDialog.case.data.case.histoProcedureId && (
              <>
                Histo Procedure ID: <b>{archiveCaseDialog.case.data.case.histoProcedureId}</b>
                <br />
              </>
            )}
            {archiveCaseDialog.case.data.case.procId && (
              <>
                Endo Procedure ID: <b>{archiveCaseDialog.case.data.case.procId}</b>
              </>
            )}
          </Box>
          <Box style={{ marginTop: 12 }}>
            Reason for Change*
            <ReasonForChange
              rkey="archiveCase_reason"
              value={archiveCaseDialog.case.data.reasonForChange || ""}
              onChange={onChangeReasonForChange}
            />
          </Box>
        </DialogBody>
        <DialogFooter>
          <Button
            onClick={onConfirm}
            disabled={confirmDisabled}
            appearance="prominent"
            intent="danger"
          >
            Confirm
          </Button>
          <Button onClick={closeDialog}>Cancel</Button>
        </DialogFooter>
      </Dialog>
    )) ||
    null
  );
};

export default archiveCaseDialog;
